/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DuringYourStayUserDataApiDto } from './during-your-stay-user-data.model';

export interface QuoteLeadUserDataApiDto {
  title?: QuoteLeadUserDataApiDto.TitleEnum;
  firstName?: string;
  lastName?: string;
  identityDocument?: string;
  guardianFirstName?: string;
  guardianLastName?: string;
  guardianEmail?: string;
  guardianPhone?: string;
  email?: string;
  phoneNumber?: string;
  countryOfResidence?: string;
  address?: string;
  address2?: string;
  /**
   * Sales force region code. By Email My Quotes feature
   */
  regionCode?: string;
  /**
   * Student residency city.
   */
  city?: string;
  /**
   * Student residency postal code.
   */
  postcode?: string;
  /**
   * Student region, state or province address.
   */
  regionStateProvince?: string;
  accommodationType?: string;
  dateOfBirth?: string;
  placeOfBirth?: string;
  nationality?: string;
  nationalityName?: string;
  motherTongue?: string;
  motherTongueName?: string;
  consentResellers?: boolean;
  consentMarketing?: boolean;
  whatsappOptIn?: boolean;
  /**
   * True when the submission originates from a Positively Languages website. False or omitted for Kaplan submissions.
   */
  positivelyLanguagesOrigin?: boolean;
  publication?: string;
  recordType?: string;
  leadType?: string;
  leadSource?: string;
  websiteLanguage?: string;
  displayPhone?: boolean;
  duringYourStay?: DuringYourStayUserDataApiDto;
  selectedInsuranceOptions?: Array<QuoteLeadUserDataApiDto.SelectedInsuranceOptionsEnum>;
  roiFirst?: string;
  roiCurrent?: string;
  urlOrigin?: string;
  urlCurrent?: string;
  urlReferer?: string;
  referredID?: string;
  specialRequests?: string;
  courseType?: string;
  hasAllergiesConditionsOrTreatments?: boolean;
  allergiesConditionsOrTreatments?: string;
  isMinor?: boolean;
  emergencyContactFirstName?: string;
  emergencyContactLastName?: string;
  emergencyContactEmail?: string;
  emergencyContactPhone?: string;
  termsAndConditionsConsent?: boolean;
  hasMedicalInsuranceProof?: boolean;
  /**
   * User\'s timezone for online course scheduling (e.g., \'America/New_York\')
   */
  timeZone?: string;
  /**
   * Preferred class time slot for online courses
   */
  preferredClassTime?: string;
  /** @deprecated */
  quoteId?: string;
}
export namespace QuoteLeadUserDataApiDto {
  export const TitleEnum = {
    MR: 'MR',
    MRS: 'MRS',
    MS: 'MS',
    MISS: 'MISS',
  } as const;
  export type TitleEnum = (typeof TitleEnum)[keyof typeof TitleEnum];
  export const SelectedInsuranceOptionsEnum = {
    CANCELLATION_INSURANCE: 'CANCELLATION_INSURANCE',
    TRAVEL_AND_MEDICAL_INSURANCE: 'TRAVEL_AND_MEDICAL_INSURANCE',
    SECOND_EXAM_CERTIFICATION_GUARANTEE: 'SECOND_EXAM_CERTIFICATION_GUARANTEE',
    EXAM_FREE_CANCELLATION_GUARANTEE: 'EXAM_FREE_CANCELLATION_GUARANTEE',
    FLEX_BOOKING: 'FLEX_BOOKING',
    MORE_INFORMATION: 'MORE_INFORMATION',
  } as const;
  export type SelectedInsuranceOptionsEnum = (typeof SelectedInsuranceOptionsEnum)[keyof typeof SelectedInsuranceOptionsEnum];
}
